package com.mgacreative.hotel.shared.ui.designsystem.di

import com.mgacreative.hotel.core.network.SupabaseNetworkClient
import com.mgacreative.hotel.core.tenant.TenantSession
import org.koin.dsl.module

fun getCommonAppModule() = module {
    single { TenantSession() }
    single { SupabaseNetworkClient() }
    single { get<SupabaseNetworkClient>().client }
}
